import React from 'react';
import './QuickActions.css';
import { useConversation } from '../../state/ConversationContext';
import { mockQuickActions } from '../../data/mockEmbeds';

export default function QuickActions() {
  const { setDraftText } = useConversation();
  return (
    <div className="quick-actions" role="list">
      {mockQuickActions.map((qa) => (
        <button
          key={qa.label}
          className="quick-action-card"
          role="listitem"
          onClick={() => setDraftText(qa.text)}
        >
          <div className="quick-action-label">{qa.label}</div>
          <div className="quick-action-text">{qa.text}</div>
        </button>
      ))}
    </div>
  );
}
